import { generateStepContent } from "../utils/helper";
import setupIcon from '../assets/icons/setup-icon.png'
import { KeyRound } from 'lucide-react';
import { UserRoundPlus } from 'lucide-react';
import { FilePlus2 } from 'lucide-react';
import { FilePenLine } from 'lucide-react';
import { Package } from 'lucide-react';
import { Sparkles } from 'lucide-react';

export const TUTORIAL_TOURS = (TOURS) => ({
    SETUP_TOUR: {
        id: "SETUP_TOUR",
        initialRoute: '/dashboard',
        steps: [
            {
                target: '#setup',
                content: generateStepContent(TOURS.SETUP_TOUR.steps.SETUP_MENU.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.SETUP_TOUR.steps.SETUP_MENU.title,
                data: { next: '/setup' },
            },
            {
                target: '#source-wrapper-adobe-target',
                content: generateStepContent(TOURS.SETUP_TOUR.steps.ADOBE_TARGET_ACTIVATION.content),
                title: TOURS.SETUP_TOUR.steps.ADOBE_TARGET_ACTIVATION.title,
                spotlightClicks: true,
                disableOverlayClose: true,
            },
            {
                target: '#manage-adobe-target',
                content: generateStepContent(TOURS.SETUP_TOUR.steps.CONFIGURATION_MANAGEMENT.content),
                title: TOURS.SETUP_TOUR.steps.CONFIGURATION_MANAGEMENT.title,
                disableOverlayClose: true,
                data: { next: '/setup/adobeIO-integrations' },
            },
            {
                target: '#create-adobeIo-cta',
                content: generateStepContent(TOURS.SETUP_TOUR.steps.NEW_INTEGRATION.content),
                title: TOURS.SETUP_TOUR.steps.NEW_INTEGRATION.title,
                disableOverlayClose: true,
                disableBeacon: true,
                data: { next: '/setup/new-integration', previous: '/setup' },
            },
            {
                target: '#adobeIo-integration-form',
                content: generateStepContent(TOURS.SETUP_TOUR.steps.INTEGRATION_FORM.content),
                title: TOURS.SETUP_TOUR.steps.INTEGRATION_FORM.title,
                placement: 'right',
                disableOverlayClose: true,
                disableBeacon: true,
                data: { previous: '/setup/adobeIO-integrations' },
            },
            {
                target: '#submit-adobeIo-integration',
                content: (TOURS.SETUP_TOUR.steps.SUBMIT_FORM.content),
                disableOverlayClose: true,
                title: TOURS.SETUP_TOUR.steps.SUBMIT_FORM.title,
                disableBeacon: true,
            },
            {
                target: '#global-selector',
                content: generateStepContent(TOURS.SETUP_TOUR.steps.GLOBAL_SELECTOR.content),
                disableOverlayClose: true,
                title: TOURS.SETUP_TOUR.steps.GLOBAL_SELECTOR.title,
                disableBeacon: true,
            }
        ]
    },

    RESET_PASSWORD_TOUR: {
        id: "RESET_PASSWORD_TOUR",
        initialRoute: '/dashboard',
        steps: [
            {
                target: '#navbar-menu',
                content: generateStepContent(TOURS.RESET_PASSWORD_TOUR.steps.OPEN_MENU.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RESET_PASSWORD_TOUR.steps.OPEN_MENU.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#profile-menu-id',
                content: generateStepContent(TOURS.RESET_PASSWORD_TOUR.steps.CLICK_PROFILE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RESET_PASSWORD_TOUR.steps.CLICK_PROFILE.title,
                data: { next: '/settings/profile',  },
            },
            {
                target: '#send-reset-password-email-btn',
                content: generateStepContent(TOURS.RESET_PASSWORD_TOUR.steps.SEND_RESET_PASSWORD_EMAIL_BTN.content),
                spotlightClicks: true,
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RESET_PASSWORD_TOUR.steps.SEND_RESET_PASSWORD_EMAIL_BTN.title,
                data: { previous: "/dashboard" }
            },
        ]
    },

    INVITE_USER_TOUR: {
        id: "INVITE_USER_TOUR",
        initialRoute: '/dashboard',
        steps: [
            {
                target: '#navbar-menu',
                content: generateStepContent(TOURS.INVITE_USER_TOUR.steps.OPEN_MENU.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.INVITE_USER_TOUR.steps.OPEN_MENU.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#manage-users-menu-id',
                content: generateStepContent(TOURS.INVITE_USER_TOUR.steps.CLICK_MANAGE_USERS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.INVITE_USER_TOUR.steps.CLICK_MANAGE_USERS.title,
                data: { isClickRequiredOnSpotlight : true },
            },
            {
                target: '#invite-user-button-id',
                content: generateStepContent(TOURS.INVITE_USER_TOUR.steps.INVITE_USER_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.INVITE_USER_TOUR.steps.INVITE_USER_BTN.title,
                data: { isClickRequiredOnSpotlight: true }
            },
            {
                target: '#invite-user-form-id',
                content: generateStepContent(TOURS.INVITE_USER_TOUR.steps.ENTER_EMAIL_NAME_ROLE.content),
                spotlightClicks: true,
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.INVITE_USER_TOUR.steps.ENTER_EMAIL_NAME_ROLE.title,
                data: {  }
            },
            {
                target: '#send-invite-user-button-id',
                content: generateStepContent(TOURS.INVITE_USER_TOUR.steps.SEND_INVITATION_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.INVITE_USER_TOUR.steps.SEND_INVITATION_BTN.title,
                data: {  }
            },
        ]
    },

    UPGRADE_PLAN_TOUR: {
        id: "UPGRADE_PLAN_TOUR",
        initialRoute: '/settings/my-plan',
        steps: [
            {
                target: '#my-plan-actions-dropdown-btn',
                content: generateStepContent(TOURS?.UPGRADE_PLAN_TOUR?.steps?.OPEN_ACTIONS?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.UPGRADE_PLAN_TOUR?.steps?.OPEN_ACTIONS?.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#upgrade-plan-dropdown-option',
                content: generateStepContent(TOURS?.UPGRADE_PLAN_TOUR?.steps?.CLICK_UPGRADE?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.UPGRADE_PLAN_TOUR?.steps?.CLICK_UPGRADE?.title,
                data: { isClickRequiredOnSpotlight: true, next: '/pricing' },
            },
            {
                target: '#billing-cycle-tab-yearly',
                content: generateStepContent(TOURS?.UPGRADE_PLAN_TOUR?.steps?.SELECT_CYCLE?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                title: TOURS?.UPGRADE_PLAN_TOUR?.steps?.SELECT_CYCLE?.title,
                data: { previous: '/settings/my-plan' },
            },
            {
                target: '#purchase-plan-btn-0',
                content: generateStepContent(TOURS?.UPGRADE_PLAN_TOUR?.steps?.PURCHASE_BUTTON?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.UPGRADE_PLAN_TOUR?.steps?.PURCHASE_BUTTON?.title,
                data: { isClickRequiredOnSpotlight: true },
            }
        ]
    },

    PURCHASE_TOPUP_TOUR: {
        id: "PURCHASE_TOPUP_TOUR",
        initialRoute: '/settings/my-plan',
        steps: [
            {
                target: '#my-plan-actions-dropdown-btn',
                content: generateStepContent(TOURS?.PURCHASE_TOPUP_TOUR?.steps?.OPEN_ACTIONS?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.PURCHASE_TOPUP_TOUR?.steps?.OPEN_ACTIONS?.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#upgrade-plan-dropdown-option',
                content: generateStepContent(TOURS?.PURCHASE_TOPUP_TOUR?.steps?.NAVIGATE_PRICING?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.PURCHASE_TOPUP_TOUR?.steps?.NAVIGATE_PRICING?.title || 'Go To Pricing',
                data: { isClickRequiredOnSpotlight: true, next: '/pricing' },
            },
            {
                target: '#billing-cycle-tab-topups',
                content: generateStepContent(TOURS?.PURCHASE_TOPUP_TOUR?.steps?.SELECT_TOPUPS?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.PURCHASE_TOPUP_TOUR?.steps?.SELECT_TOPUPS?.title,
                data: { isClickRequiredOnSpotlight: true, previous: '/settings/my-plan' },
            },
            {
                target: '#purchase-plan-btn-0',
                content: generateStepContent(TOURS?.PURCHASE_TOPUP_TOUR?.steps?.PURCHASE_TOPUP?.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.PURCHASE_TOPUP_TOUR?.steps?.PURCHASE_TOPUP?.title,
                data: { isClickRequiredOnSpotlight: true },
            }
        ]
    },

    CREATE_EXPERIENCE_TOUR: {
        id: "CREATE_EXPERIENCE_TOUR",
        initialRoute: '/experience/manage-experiences',
        steps: [
            {
                target: '#create-experience-btn-id',
                content: generateStepContent(TOURS.CREATE_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.title,
                data: { next: '/experience/create-experience' },
            },
            {
                target: '#choose-first-template-id',
                content: generateStepContent(TOURS.CREATE_EXPERIENCE_TOUR.steps.CHOOSE_TEMPLATE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_EXPERIENCE_TOUR.steps.CHOOSE_TEMPLATE.title,
                data: { previous: '/experience/manage-experiences', isClickRequiredOnSpotlight: true },
            },
            {
                target: '#configure-experience-form-id',
                content: generateStepContent(TOURS.CREATE_EXPERIENCE_TOUR.steps.CONFIG_EXP_FORM.content),
                disableBeacon: true,
                spotlightClicks: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_EXPERIENCE_TOUR.steps.CONFIG_EXP_FORM.title,
            },
            {
                target: '#apply-config-exp-changes-btn-id',
                content: generateStepContent(TOURS.CREATE_EXPERIENCE_TOUR.steps.APPLY_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_EXPERIENCE_TOUR.steps.APPLY_BTN.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#go-to-next-step-btn-id',
                content: generateStepContent(TOURS.CREATE_EXPERIENCE_TOUR.steps.NEXT_STEP.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_EXPERIENCE_TOUR.steps.NEXT_STEP.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#save-as-experience-btn-id',
                content: generateStepContent(TOURS.CREATE_EXPERIENCE_TOUR.steps.SAVE_AS_EXPERIENCE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_EXPERIENCE_TOUR.steps.SAVE_AS_EXPERIENCE.title,
                data: { isClickRequiredOnSpotlight: true },
            },
        ]
    },

    EDIT_DRAFT_EXPERIENCE_TOUR: {
        id: "EDIT_DRAFT_EXPERIENCE_TOUR",
        initialRoute: '/experience/manage-experiences',
        steps: [
            {
                target: '#edit-first-draft-experience-btn-id',
                content: generateStepContent(TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.content),
                disableBeacon: true,
                placement: 'right',
                disableOverlayClose: true,
                title: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.title,
                data: { isClickRequiredOnSpotlight: true},
            },
            {
                target: '#experience-detail-edit-btn-id',
                content: generateStepContent(TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.EXPERIENCE_DETAILS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.EXPERIENCE_DETAILS.title,
                data: { isClickRequiredOnSpotlight: true, previous: "/experience/manage-experiences" },
            },
            {
                target: '#configure-experience-form-id',
                content: generateStepContent(TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.CONFIG_EXP_FORM.content),
                disableBeacon: true,
                spotlightClicks: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.CONFIG_EXP_FORM.title,
                data: { previous: "/experience/experience-details/routeId"},
            },
            {
                target: '#apply-config-exp-changes-btn-id',
                content: generateStepContent(TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.APPLY_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.APPLY_BTN.title,
                data: { isClickRequiredOnSpotlight: true , previous: "/experience/edit-experience/routeId"},
            },
            { 
                target: '#go-to-next-step-btn-id',
                content: generateStepContent(TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.NEXT_STEP.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.NEXT_STEP.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#save-as-experience-btn-id',
                content: generateStepContent(TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.SAVE_AS_EXPERIENCE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.steps.SAVE_AS_EXPERIENCE.title,
                data: { isClickRequiredOnSpotlight: true },
                hideBackButton: true,
            },
        ]
    },
    EDIT_PUBLISHED_EXPERIENCE_TOUR: {
        id: "EDIT_PUBLISHED_EXPERIENCE_TOUR",
        initialRoute: '/experience/manage-experiences',
        steps: [
            {
                target: '#edit-first-published-experience-btn-id',
                content: generateStepContent(TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.content),
                disableBeacon: true,
                placement: 'right',
                disableOverlayClose: true,
                title: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.title,
                data: { isClickRequiredOnSpotlight: true},
            },
            {
                target: '#experience-detail-edit-btn-id',
                content: generateStepContent(TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.EXPERIENCE_DETAILS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.EXPERIENCE_DETAILS.title,
                data: { isClickRequiredOnSpotlight: true, previous: "/experience/manage-experiences" },
            },
            {
                target: '#configure-experience-form-id',
                content: generateStepContent(TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.CONFIG_EXP_FORM.content),
                disableBeacon: true,
                spotlightClicks: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.CONFIG_EXP_FORM.title,
                data: { previous: "/experience/experience-details/routeId"},
            },
            {
                target: '#apply-config-exp-changes-btn-id',
                content: generateStepContent(TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.APPLY_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.APPLY_BTN.title,
                data: { isClickRequiredOnSpotlight: true , previous: "/experience/edit-experience/routeId"},
            },
            { 
                target: '#go-to-next-step-btn-id',
                content: generateStepContent(TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.NEXT_STEP.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.NEXT_STEP.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#save-as-experience-btn-id',
                content: generateStepContent(TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.SAVE_AS_EXPERIENCE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.steps.SAVE_AS_EXPERIENCE.title,
                data: { isClickRequiredOnSpotlight: true },
                hideBackButton: true,
            },
        ]
    },

    BULK_UPLOAD_EXPERIENCE_TOUR: {
        id: "BULK_UPLOAD_EXPERIENCE_TOUR",
        initialRoute: '/experience/manage-experiences',
        steps: [
            {
                target: '#bulk-upload-experience-btn-id',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.MANAGE_EXPERIENCE.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#open-select-item-dropdown',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.SELECT_TEMPLATE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                hideBackButton: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.SELECT_TEMPLATE.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#select-first-item-from-dropdown',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.SELECT_TEMPLATE.content),
                placement: 'right',
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.SELECT_TEMPLATE.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#download-sample-csv-btn-id',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.DOWNLOAD_SAMPLE_CSV_FILE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.DOWNLOAD_SAMPLE_CSV_FILE.title,
                data: { isClickRequiredOnSpotlight: true }
            },
            {
                target: '#upload-csv-file-id',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.UPLOAD_CSV_FILE.content),
                spotlightClicks: true,
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.UPLOAD_CSV_FILE.title,
                data: {  },
            },
            {
                target: '#first-row-action-of-preview-id',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.OPEN_ACTION_MENU_OF_FIRST_ROW.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.OPEN_ACTION_MENU_OF_FIRST_ROW.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#add-duplicate-of-first-row-btn-id',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.ADD_DUPLICATE_ROW.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.ADD_DUPLICATE_ROW.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#experience-preview-table-id',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.EDIT_CELL.content),
                spotlightClicks: true,
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.EDIT_CELL.title,
                data: {  },
            },
            {
                target: '#submit-btn-id',
                content: generateStepContent(TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.SUBMIT_BUTTON.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.steps.SUBMIT_BUTTON.title,
                data: {  },
            },
        ]
    },

    CREATE_TEMPLATE_TOUR: {
        id: "CREATE_TEMPLATE_TOUR",
        initialRoute: '/experience/manage-templates',
        steps: [
            {
                target: '#create-template-btn-id',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.CREATE_TEMPLATE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.CREATE_TEMPLATE.title,
                data: { next: '/experience/create-template' }
            },
            {
                target: '#template-field-platform',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_PLATFORM.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_PLATFORM.title,
                placement : "right",
                spotlightClicks: true,
                data : { previous : "/experience/manage-templates"}
            },
            {
                target: '#template_icon_url_mobile_only',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_MOBILE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_MOBILE.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["web_only"]
            },
            {
                target: '#template_icon_url_web_only',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["mobile_only"]
            },
            {
                target: '#template_view_url_mobile_portrait',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["web_only", "responsive"]
            },
            {
                target: '#template_view_url_mobile_landscape',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["web_only", "responsive"]
            },
            { 
                target: '#template-field-source',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SOURCE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SOURCE.title,
                placement : "right",
                spotlightClicks: true,
            },
            { 
                target: '#api_end_point',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_API_ENDPOINT.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_API_ENDPOINT.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["database"]
            },
            { 
                target: '#template-field-landscape',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_LANDSCAPE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_LANDSCAPE.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["web_only"]
            },
            { 
                target: '#template-html',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_HTML.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_HTML.title,
                placement : "right",
                spotlightClicks: true
            },
            { 
                target: '#template-css',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CSS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CSS.title,
                placement : "right",
                spotlightClicks: true
            },
            { 
                target: '#template-json-schema',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_JSON_SCHEMA.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_JSON_SCHEMA.title,
                placement : "right",
                spotlightClicks: true
            },
            { 
                target: '#template-config-json-edit-icon',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_ICON.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_ICON.title,
                placement : "right",
                data : { isClickRequiredOnSpotlight : true}
            },
            { 
                target: '#template-config-json-edit-grid',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_GRID.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_GRID.title,
                spotlightClicks: true,
            },
            { 
                target: '#submit-btn-id',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SUBMIT_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SUBMIT_BTN.title,
                data : { isClickRequiredOnSpotlight : true}
            },
            {
                target: '#configure-template-apply-id',
                disableBeacon: true,
                disableOverlayClose: true,
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_PREVIEW_BTN.content),
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_PREVIEW_BTN.title,
                data : { isClickRequiredOnSpotlight : true}
            },
            {
                target: '#configure-template-save-id',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_BTN.title,
                data : { isClickRequiredOnSpotlight : true}
            },
            {
                target: '#template_name',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_NAME_FIELD.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_NAME_FIELD.title,
                spotlightClicks: true
            },
            {
                target: '#save-template-name',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_NAME.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_NAME.title,
                data : { isClickRequiredOnSpotlight : true}
            },
        ]
    },

    CREATE_TEMPLATE_HELP_TOUR: {
        id: "CREATE_TEMPLATE_HELP_TOUR",
        initialRoute: '/experience/create-template',
        steps: [
            {
                target: '#template-field-platform',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_PLATFORM.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_PLATFORM.title,
                placement : "right",
                spotlightClicks: true
            },
            {
                target: '#template_icon_url_mobile_only',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_MOBILE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_MOBILE.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["web_only"]
            },
            {
                target: '#template_icon_url_web_only',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_FIELDS_ICON_WEB.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["mobile_only"]
            },
            { 
                target: '#template-field-source',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SOURCE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SOURCE.title,
                placement : "right",
                spotlightClicks: true,
            },
            { 
                target: '#api_end_point',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_API_ENDPOINT.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_API_ENDPOINT.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["database"]
            },
            { 
                target: '#template-field-landscape',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_LANDSCAPE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_LANDSCAPE.title,
                placement : "right",
                spotlightClicks: true,
                hideStep : ["web_only"]
            },
            { 
                target: '#template-html',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_HTML.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_HTML.title,
                placement : "right",
                spotlightClicks: true
            },
            { 
                target: '#template-css',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CSS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CSS.title,
                placement : "right",
                spotlightClicks: true
            },
            { 
                target: '#template-json-schema',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_JSON_SCHEMA.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_JSON_SCHEMA.title,
                placement : "right",
                spotlightClicks: true
            },
            { 
                target: '#template-config-json-edit-icon',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_ICON.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_ICON.title,
                placement : "right",
                data : { isClickRequiredOnSpotlight : true}
            },
            { 
                target: '#template-config-json-edit-grid',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_GRID.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_CONFIG_GRID.title,
                spotlightClicks: true,
            },
            { 
                target: '#submit-btn-id',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SUBMIT_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SUBMIT_BTN.title,
                data : { isClickRequiredOnSpotlight : true}
            },
            {
                target: '#configure-template-apply-id',
                disableBeacon: true,
                disableOverlayClose: true,
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_PREVIEW_BTN.content),
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_PREVIEW_BTN.title,
                data : { isClickRequiredOnSpotlight : true}
            },
            {
                target: '#configure-template-save-id',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_BTN.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_BTN.title,
                data : { isClickRequiredOnSpotlight : true}
            },
            {
                target: '#template_name',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_NAME_FIELD.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_NAME_FIELD.title,
                spotlightClicks: true
            },
            {
                target: '#save-template-name',
                content: generateStepContent(TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_NAME.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.CREATE_TEMPLATE_TOUR.steps.TEMP_SAVE_NAME.title,
                data : { isClickRequiredOnSpotlight : true}
            },
        ]
    },

    ONE_OFF_TASK_TOUR: {
        id: "ONE_OFF_TASK_TOUR",
        initialRoute: '/functions',
        steps: [
            {
                target: '#function-card-offers',
                content: generateStepContent(TOURS.ONE_OFF_TASK_TOUR.steps.SELECT_TASK.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.ONE_OFF_TASK_TOUR.steps.SELECT_TASK.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#save-task-button',
                content: generateStepContent(TOURS.ONE_OFF_TASK_TOUR.steps.SAVE_TASK.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.ONE_OFF_TASK_TOUR.steps.SAVE_TASK.title,
                data: { isClickRequiredOnSpotlight: true, previous: "/functions" },
            },
            {
                target: '#name', // Attach to the name input field in modal
                content: generateStepContent(TOURS.ONE_OFF_TASK_TOUR.steps.NAME_TASK.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.ONE_OFF_TASK_TOUR.steps.NAME_TASK.title,
                spotlightClicks: true,
                data: { previous : "/functions/one-off-tasks/offers"},
            },
            {
                // Step 5: Submit the form (save button in modal)
                target: '#save-task', // Attach to submit button in modal
                content: generateStepContent(TOURS.ONE_OFF_TASK_TOUR.steps.SUBMIT_TASK.content),
                disableBeacon: false,
                disableOverlayClose: true,
                title: TOURS.ONE_OFF_TASK_TOUR.steps.SUBMIT_TASK.title,
                data: { next : "/functions/saved-tasks" },
            },
            {
                target: '#saved-tasks-table', // Attach to the saved tasks table heading
                content: generateStepContent(TOURS.ONE_OFF_TASK_TOUR.steps.TOUR_COMPLETE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                hideBackButton: true,
                title: TOURS.ONE_OFF_TASK_TOUR.steps.TOUR_COMPLETE.title,
                data: {},
            },
        ]
    },

    RECURRING_TASK_TOUR : {
        id: "RECURRING_TASK_TOUR",
        initialRoute: '/functions',
        steps: [
            {
                target: '#function-card-validate_activity_name',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.SELECT_TASK.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.SELECT_TASK.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#saved_task_name',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.NAME_TASK.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.NAME_TASK.title,
                spotlightClicks: true,
                data: { previous: "/functions" },
            },
            {
                target: '#tour-adobe_io_integration_id-open-select-item-dropdown',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.CHOOSE_ADOBE_IO.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.CHOOSE_ADOBE_IO.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#select-first-item-from-dropdown',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.CHOOSE_ADOBE_IO.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.CHOOSE_ADOBE_IO.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#tour-time_interval-open-select-item-dropdown',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.SET_FREQUENCY.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.SET_FREQUENCY.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#select-first-item-from-dropdown',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.SET_FREQUENCY.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.SET_FREQUENCY.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#tour-status-open-select-item-dropdown',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.SET_STATUS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.SET_STATUS.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#select-first-item-from-dropdown',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.SET_STATUS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.SET_STATUS.title,
                data: { isClickRequiredOnSpotlight: true },
            },
            {
                target: '#tour-filter_type',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.CHOOSE_FILTER_TYPE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.CHOOSE_FILTER_TYPE.title,
            },
            {
                target: '#tour-filter_value',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.ENTER_FILTER_VALUE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.ENTER_FILTER_VALUE.title,
            },
            {
                target: '#tour-email_input',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.ADD_RECIPIENTS.content),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.ADD_RECIPIENTS.title,
            },
            {
                target: '#submit-activity-name-form',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.SAVE_TASK.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.SAVE_TASK.title,
                data: { next: "/functions/saved-tasks" },
            },
            {
                target: '#saved-tasks-table',
                content: generateStepContent(TOURS.RECURRING_TASK_TOUR.steps.TOUR_COMPLETE.content),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS.RECURRING_TASK_TOUR.steps.TOUR_COMPLETE.title,
                hideBackButton: true,
            },
        ]
    },

    AI_ASSISTANT_TOUR: {
        id: "AI_ASSISTANT_TOUR",
        steps: [
            {
                target: '#ai-assistant-launcher',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.LAUNCHER?.content || "Click the AI Assistant icon anytime from anywhere in the application to open the assistant panel."),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.LAUNCHER?.title || "AI Assistant Launcher",
            },
            {
                target: '#ai-history-btn',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.HISTORY?.content || "Access your past conversations, review previous responses, or resume an existing chat session."),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.HISTORY?.title || "Conversation History",
            },
            {
                target: '#ai-connectors-trigger',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.OPEN_CONNECTORS?.content || "Click here to open the Connectors menu and view the data sources available for your queries."),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.OPEN_CONNECTORS?.title || "Open Connectors Menu",
            },
            {
                target: '#ai-connector-item-0',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.TOGGLE_CONNECTOR?.content || "Click here to toggle individual connectors (such as Adobe Target, Adobe Analytics, or Tealium) on or off. You can query one tool exclusively or combine multiple tools together."),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.TOGGLE_CONNECTOR?.title || "Toggle a Connector",
            },
            {
                target: '#ai-project-picker',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.PROJECTS?.content || "Click here to open the Project Manager where you can create projects, configure custom prompts, manage context files, or switch your active project."),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.PROJECTS?.title || "Manage Projects",
            },
            {
                target: '#ai-project-footer-btn',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.PROJECT_FOOTER?.content || "Click here to change your active project. Just like 'Manage project' in the header, both open the same modal where you can select a different project, add new projects, or update context."),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                placement: 'top',
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.PROJECT_FOOTER?.title || "Change Active Project",
            },
            {
                target: '#ai-library-btn',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.LIBRARY?.content || "Click Library to view and download context files, specifications, guidelines, and reference documents used by the AI assistant."),
                disableBeacon: true,
                disableOverlayClose: true,
                spotlightClicks: true,
                placement: 'top',
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.LIBRARY?.title || "Project Library",
            },
            {
                target: '#ai-chat-input-container',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.COMPOSER?.content || "Enter your prompt or select from curated suggested questions to quickly generate answers, analyze data, or create templates."),
                disableBeacon: true,
                disableOverlayClose: true,
                placement: 'top',
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.COMPOSER?.title || "Prompt Composer & Suggestions",
            },
            {
                target: '#ai-model-picker',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.MODEL_PICKER?.content || "Switch between available AI models to tailor reasoning capability and response speed to your task."),
                disableBeacon: true,
                disableOverlayClose: true,
                placement: 'top',
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.MODEL_PICKER?.title || "Model Selection",
            },
            {
                target: '#ai-clear-btn',
                content: generateStepContent(TOURS?.AI_ASSISTANT_TOUR?.steps?.NEW_CHAT?.content || "Click here to start the conversation over with a clean slate."),
                disableBeacon: true,
                disableOverlayClose: true,
                title: TOURS?.AI_ASSISTANT_TOUR?.steps?.NEW_CHAT?.title || "New Chat",
            },
        ]
    }

});

export const ProductTours = (TOURS) => ([
    {
        title: TOURS.SETUP_TOUR.title,
        description: TOURS.SETUP_TOUR.description,
        tourKey: 'SETUP_TOUR',
        showForOrgLevels: ['3'],
        icon: <img src={setupIcon} alt='setup-icon' className='flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900'/>
    },
    {
        title: TOURS.RESET_PASSWORD_TOUR.title,
        description: TOURS.RESET_PASSWORD_TOUR.description,
        tourKey: 'RESET_PASSWORD_TOUR',
        icon: <KeyRound className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS.INVITE_USER_TOUR.title,
        description: TOURS.INVITE_USER_TOUR.description,
        tourKey: 'INVITE_USER_TOUR',
        icon: <UserRoundPlus className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>,
        role: ['Owner']
    },
    {
        title: TOURS.CREATE_EXPERIENCE_TOUR.title,
        description: TOURS.CREATE_EXPERIENCE_TOUR.description,
        tourKey: 'CREATE_EXPERIENCE_TOUR',
        icon: <FilePlus2 className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS.CREATE_TEMPLATE_TOUR.title,
        description: TOURS.CREATE_TEMPLATE_TOUR.description,
        tourKey: 'CREATE_TEMPLATE_TOUR',
        icon: <FilePlus2 className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.title,
        description: TOURS.EDIT_DRAFT_EXPERIENCE_TOUR.description,
        tourKey: 'EDIT_DRAFT_EXPERIENCE_TOUR',
        icon: <FilePenLine className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.title,
        description: TOURS.EDIT_PUBLISHED_EXPERIENCE_TOUR.description,
        tourKey: 'EDIT_PUBLISHED_EXPERIENCE_TOUR',
        icon: <FilePenLine className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.title,
        description: TOURS.BULK_UPLOAD_EXPERIENCE_TOUR.description,
        tourKey: 'BULK_UPLOAD_EXPERIENCE_TOUR',
        icon: <Package className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS.ONE_OFF_TASK_TOUR.title,
        description: TOURS.ONE_OFF_TASK_TOUR.description,
        tourKey: 'ONE_OFF_TASK_TOUR',
        icon: <Package className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS.RECURRING_TASK_TOUR.title,
        description: TOURS.RECURRING_TASK_TOUR.description,
        tourKey: 'RECURRING_TASK_TOUR',
        icon: <Package className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS?.UPGRADE_PLAN_TOUR?.title || "Upgrade Plan",
        description: TOURS?.UPGRADE_PLAN_TOUR?.description || "Step-by-step guide to upgrading your subscription plan.",
        tourKey: 'UPGRADE_PLAN_TOUR',
        icon: <Package className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS?.PURCHASE_TOPUP_TOUR?.title || "Purchase Top-up",
        description: TOURS?.PURCHASE_TOPUP_TOUR?.description || "Step-by-step guide to adding top-up credits to your current billing cycle.",
        tourKey: 'PURCHASE_TOPUP_TOUR',
        icon: <Package className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    },
    {
        title: TOURS?.AI_ASSISTANT_TOUR?.title || "AI Assistant",
        description: TOURS?.AI_ASSISTANT_TOUR?.description || "Step-by-step guide to using the AI Assistant, connecting tools, managing projects, and running prompts.",
        tourKey: 'AI_ASSISTANT_TOUR',
        icon: <Sparkles className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"/>
    }
]);